import { render, staticRenderFns } from "./AnalitPropertyValues.vue?vue&type=template&id=0985d557&scoped=true"
import script from "./AnalitPropertyValues.vue?vue&type=script&lang=js"
export * from "./AnalitPropertyValues.vue?vue&type=script&lang=js"
import style0 from "./AnalitPropertyValues.vue?vue&type=style&index=0&id=0985d557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985d557",
  null
  
)

export default component.exports